import React from 'react'
import env from './../../environments/environment'
import PAGE_CONFIG from './../../constants/public-facing'

const renderPoints = (points) => {
  const li1 = [],
    li2 = []
  points.forEach((p, i) => {
    if (i % 2 === 0)
      li1.push(
        <li className="text-usabg-blue" key={'abt-pt-1-' + i}>
          {p.name}
        </li>
      )
    else
      li2.push(
        <li className="text-usabg-blue" key={'abt-pt-2-' + i}>
          {p.name}
        </li>
      )
  })

  return (
    <>
      <div className="cell-sm-5">
        <ul className="list-marked-dotted">{li1}</ul>
      </div>
      <div className="cell-sm-7">
        <ul className="list-marked-dotted">{li2}</ul>
      </div>
    </>
  )
}

const About = ({ config }) => (
  <section
    id={config?.id || 'about-us'}
    className="section-50 bg-whisper-1 section-md-75 section-md-90 section-lg-100"
    style={{ position: 'relative' }}
  >
    <div className="shell">
      <div className="range range-md-middle">
        <div className="cell-md-6">
          <div className="video-wrap">
            <figure>
              <img
                src={`https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fimg.ribbon-cutting-new.jpg?alt=media`}
                width="571"
                height="378"
                alt=""
                className="img-responsive"
              />
            </figure>
            {config?.youtubeUrl ? (
              <a
                data-lightbox="iframe"
                href={config?.youtubeUrl}
                className="link-circle link-white"
                target="_BLANK"
                rel="noopener noreferrer"
              >
                <span className="icon icon-xl fl-36-slim-icons-play90"></span>
              </a>
            ) : (
              <></>
            )}
          </div>
        </div>

        <div className="cell-md-6">
          <div className="inset-lg-left-70 inset-lg-right-70">
            <h2>
              <span className="sub-head-small text-blue">{config?.title}</span>
            </h2>
            <p
              className="text-cello"
              dangerouslySetInnerHTML={{ __html: config?.description }}
            ></p>
          </div>
        </div>
      </div>
    </div>
    {PAGE_CONFIG?.compliance?.enabled &&
    PAGE_CONFIG?.compliance?.entity_name ? (
      <div
        style={{
          color: '#666',
          fontSize: '16px',
          textAlign: 'center',
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          padding: '2px',
          fontWeight: 400,
          fontFamily: 'lato',
        }}
      >
        {PAGE_CONFIG.compliance.entity_name}
      </div>
    ) : (
      <></>
    )}
  </section>
)

export default About
